var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-kn",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M151.7-.3h745.1v745H151.7z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "translate(-104.2 .2) scale(.68714)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffe900",
    d: "M-5.3 0h1073.5v744H-5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#35a100",
    d: "m-5.8 0 1.2 536.4L830.7-.4-5.8 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c70000",
    d: "m1069.5 744-1.9-557.7L225 744.5l844.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-5.3 576.9.7 167.9 182.3-.3L1068 147.6l-1-146L886.9 0-5.4 576.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m818 269-64.2-2.2-25.3 60.2-14.3-61.5-64.2-2.2 55.4-35.7L691 166l48.5 39.4 55.3-35.9-25.4 60.2zM417.5 529.6l-64.3-2.3-25.2 60.2-14.3-61.5-64.3-2.2 55.4-35.8-14.4-61.4 48.5 39.4 55.3-35.9-25.3 60.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKn);
export default __webpack_public_path__ + "static/media/kn.1be879000f8ccc6bdbc1267bc3fea34f.svg";
export { ForwardRef as ReactComponent };